import { render, staticRenderFns } from "./ConfirmationDestination.vue?vue&type=template&id=bc6a7cde&scoped=true"
import script from "./ConfirmationDestination.vue?vue&type=script&lang=js"
export * from "./ConfirmationDestination.vue?vue&type=script&lang=js"
import style0 from "./ConfirmationDestination.vue?vue&type=style&index=0&id=bc6a7cde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc6a7cde",
  null
  
)

export default component.exports